import { render, staticRenderFns } from "./chatend.vue?vue&type=template&id=09a7b657"
import script from "./chatend.vue?vue&type=script&lang=js"
export * from "./chatend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports